import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-call.js";
import { a as e } from "../internals/a-callable.js";
import { g as i } from "../internals/get-built-in.js";
import "../internals/new-promise-capability.js";
import { p as o } from "../internals/perform.js";
import { i as n } from "../internals/iterate.js";
import { p as s } from "../internals/promise-statics-incorrect-iteration.js";
import { __exports as a } from "../../../_virtual/new-promise-capability.js";
var m = "No one promise resolved";
r({
  target: "Promise",
  stat: !0,
  forced: s
}, {
  any: function any(r) {
    var s = this,
      l = i("AggregateError"),
      p = a.f(s),
      f = p.resolve,
      c = p.reject,
      j = o(function () {
        var i = e(s.resolve),
          o = [],
          a = 0,
          p = 1,
          j = !1;
        n(r, function (r) {
          var e = a++,
            n = !1;
          p++, t(i, s, r).then(function (r) {
            n || j || (j = !0, f(r));
          }, function (r) {
            !n && !j && (n = !0, o[e] = r, --p || c(new l(o, m)));
          });
        }), --p || c(new l(o, m));
      });
    return j.error && c(j.value), p.promise;
  }
});